import { createContext, useContext } from "react";
import { useConfig } from '../context/ConfigContext';
import { useEffect, useState, useCallback } from "react";
import axios from 'axios';

const PageContext = createContext();

export const PageContextProvider = ({ children, isTesting}) => {
    const { backendApiBaseUrl } = useConfig();
    const [pages, setPages] = useState({});
    
    const fetchData = useCallback(async () => {
        try {
            const searchURL = new URL(`${backendApiBaseUrl}/site/pages`);
            const response = await axios.get(searchURL.toString());
            setPages(response.data.pages);
        } catch (error) {
            console.error("Error fetching pages:", error);
            setPages({
                activity: false,
                morphs: false,
                sketches: false
            });
        }
    }, [backendApiBaseUrl]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <PageContext.Provider value={{ pages, setPages }}>
            {children}
        </PageContext.Provider>
    );
};

export const usePageConfig = () => useContext(PageContext);